import type { CourseCardDto } from "@artha/api-contracts";
import type { CourseAnalyticsProperties } from "@artha/types";
import { COURSE_ANALYTICS_PROPERTIES } from "./course-analytics.constants";

/** Allowlist metadata at the analytics boundary even if callers pass extra fields. */
export function courseAnalyticsProperties(input: CourseAnalyticsProperties) {
  return Object.fromEntries(
    COURSE_ANALYTICS_PROPERTIES.filter((key) => input[key] !== undefined).map(
      (key) => [key, input[key]],
    ),
  );
}

/** Reuse safe catalog facts without spreading tokens or detailed provider payloads. */
export function courseAnalyticsContext(
  course?: CourseCardDto,
  jobId?: string,
): CourseAnalyticsProperties {
  return {
    entity_id: course?.entity_id,
    course_type: course?.course_type,
    provider_name: course?.provider_name,
    access_mode: course?.access_mode,
    is_demo: course?.is_demo,
    source_job_id: jobId,
  };
}
